// extracted by mini-css-extract-plugin
export default {"type_card__wrapper":"style_type_card__wrapper__dooxZ","type_card__icon":"style_type_card__icon__ECHL+","type_card__title":"style_type_card__title__xjSlG"};